import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replace as replaceAC } from 'react-router-redux';

import { routes } from 'config/routes';
import { getIsAuthorized } from 'selectors/auth';

class LoginRequired extends Component {
  componentWillMount() {
    this.redirectUnauthorizedUsers();
  }

  componentDidUpdate() {
    this.redirectUnauthorizedUsers();
  }

  redirectUnauthorizedUsers() {
    const { isAuthorized, replace } = this.props;

    if (!isAuthorized) {
      replace(routes.MAIN);
    }
  }

  render() {
    const { children, isAuthorized } = this.props;
    return (
      <div>
        { isAuthorized && children }
      </div>
    );
  }
}

LoginRequired.propTypes = {
  children: PropTypes.node,
  isAuthorized: PropTypes.bool.isRequired,
  replace: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    isAuthorized: getIsAuthorized(state),
  };
}

export default connect(mapStateToProps, { replace: replaceAC })(LoginRequired);



// WEBPACK FOOTER //
// ./src/components/common/LoginRequired.js